import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function QuoteAvailability({ checkIn, checkOut }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    api.get(`/quote-availability?checkin=${checkIn}&checkout=${checkOut}`).then((r) => setD(r.data)).catch(() => {});
  }, [checkIn, checkOut]);
  if (!d) return null;
  return (
    <div className="mt-2 text-xs bg-white border border-emerald-200 rounded-lg px-3 py-2" data-testid="quote-availability">
      <div className="font-semibold text-emerald-800 mb-1">🛏️ Disponibilità reale dal calendario</div>
      {d.structures.map((s) => (
        <div key={s.structure} className="flex flex-wrap gap-x-2" data-testid={`quote-avail-${s.structure}`}>
          <span className={`font-semibold ${s.free.length ? "text-emerald-700" : "text-red-600"}`}>{s.structure}: {s.free.length}/{s.total} libere</span>
          <span className="text-gray-500">{s.free.map((r, i) => r.name || `Camera ${i + 1}`).join(", ")}</span>
        </div>
      ))}
    </div>
  );
}
